export default __webpack_public_path__ + "static/media/WNo.8-14.c2970e37.jpg";